



























import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "GroupSelectedInformer",
  components: { BaseIcon },
  props: {
    selectedGroupCount: { type: [Number, String], default: 0 },
    excludedGroupCount: { type: [Number, String], default: 0 },
    recipientCount: { type: [Number, String], default: 0 },
  },
});
